/**
 * Default localized text (US English).
 */
import Field from "../Field/locale"
import Spinner from "../Spinner/locale"
import Alert from "../Alert/locale"

const en_US = {
  Alert,
  Field,
  Spinner
}

export default en_US
